const prodConfig = {
    apiKey: "AIzaSyClDF2A0HHEBfv54Lb9ptr9mEXSV-oKEpo",
    authDomain: "lets-f0eb6.firebaseapp.com",
    databaseURL: "https://lets-f0eb6.firebaseio.com",
    projectId: "lets-f0eb6",
    storageBucket: "lets-f0eb6.appspot.com",
    messagingSenderId: "450009736587",
  apiRoute: "https://us-central1-lets-f0eb6.cloudfunctions.net"
};

const devConfig = {
  apiKey: "AIzaSyClDF2A0HHEBfv54Lb9ptr9mEXSV-oKEpo",
    authDomain: "lets-f0eb6.firebaseapp.com",
    databaseURL: "https://lets-f0eb6.firebaseio.com",
    projectId: "lets-f0eb6",
    storageBucket: "lets-f0eb6.appspot.com",
    messagingSenderId: "450009736587",
    apiRoute: "http://localhost:5000/lets-f0eb6/us-central1"
};

export const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;


// WEBPACK FOOTER //
// ./src/config/firebase.js